import axios from 'axios';
import type {AxiosResponse} from 'axios';
import cardsTemplate from './templates/vacancies-item.twig';
import {Utils} from '@/common/scripts/utils';

const CLASS_ACTIVE = 'is-active';

class Vacancies {
    private wrapper: HTMLElement;
    private listWrapper: HTMLElement;
    private buttonMore: HTMLElement;
    private action: string;
    private roles: string;
    private items: HTMLElement[];
    private showCount: number = 8;
    private visibleCount: number = 0;

    public init(wrapper: HTMLElement): void {
        this.wrapper = wrapper;

        this.setElements();
        this.load();
        this.bindEvents();
    }

    private setElements(): void {
        if (!this.wrapper) {
            return;
        }

        this.listWrapper = this.wrapper.querySelector('.j-vacancies__list') as HTMLElement;
        this.buttonMore = this.wrapper.querySelector('.j-vacancies__more') as HTMLElement;
        this.action = this.wrapper.dataset['action'] || '';
        this.roles = this.wrapper.dataset['professionalroles'] || '';
        this.showCount = Number(this.wrapper.dataset['show']) || 8;
    }

    private load(): void {
        axios.post(this.action, {roles: this.roles})
            .then((response: AxiosResponse) => {
                const status = response.data.success;
                const items = response.data?.data?.items || [];

                if (status) {
                    this.insertList(items);
                    this.initVisibleItems();
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err: unknown) => {
                this.showError();
                console.error(err);
            });
    }

    private bindEvents(): void {
        if (this.buttonMore) {
            this.buttonMore.addEventListener('click', () => {
                this.showMore();
            });
        }
    }

    private insertList(items: any[]): void {
        Utils.insetContent(this.listWrapper, cardsTemplate({items}));

        this.items = [...this.listWrapper.querySelectorAll('.j-vacancies__item')] as HTMLElement[];
    }

    private showError(): void {
        //
    }

    private initVisibleItems(): void {
        if (!this.items?.length) {
            return;
        }

        this.items.slice(0, this.showCount).forEach((item: HTMLElement) => {
            item.classList.add(CLASS_ACTIVE);
        });

        this.visibleCount = this.showCount;

        this.checkVisibleButtonMore();
    }

    private showMore(): void {
        this.items.slice(this.visibleCount - 1, this.visibleCount + this.showCount).forEach((item: HTMLElement) => {
            item.classList.add(CLASS_ACTIVE);
        });

        this.visibleCount = this.visibleCount + this.showCount;

        this.checkVisibleButtonMore();
    }

    private checkVisibleButtonMore(): void {
        if (this.visibleCount >= this.items.length) {
            this.buttonMore.classList.remove(CLASS_ACTIVE);
        } else {
            this.buttonMore.classList.add(CLASS_ACTIVE);
        }
    }
}

export default Vacancies;
